import React from "react";
import "../styles/WhoWeAre.css";
import { Link } from "react-router-dom";

function WhoWeAre() {
  return (
    <section className="who-we-are">
      <h2>Who We Are</h2>
      <p>
        Zarkhani Nexus Solutions Pvt Ltd is a trusted name in the field of international import and export, delivering high-quality industrial products across global markets. We specialize in Mechanical Spare Parts, AC Tools & Accessories, Pneumatics, Electronic Repairs, Safety & PPE’s, and many more essential components for diverse industries.
      </p>
      <Link to="/about" className="explore-btn">Explore More</Link>
    </section>
  );
}

export default WhoWeAre;
